// /opt/isp_erp/frontend/src/utils/usuariosSucursal.js
import axios from "../api/axios";

/** Ids de los usuarios que pertenecen a una sucursal de bodega (reciben su material, equipos y viñetas desde esa sucursal). */
export const cargarUsuariosDeSucursal = async () => {
  try {
    const r = await axios.get("/warehouse/sucursales/usuarios-asignados");
    return new Set((r.data || []).map((u) => u.user_id));
  } catch (e) {
    return new Set();
  }
};
